export default __webpack_public_path__ + "static/media/LetsGetStarted1.102983bf.svg";